import { Box } from '@mui/material';
import { Button } from '@studykik/ui-library';
import styled from 'styled-components';
import { Colors } from '../../assets/styles/colors';

export const PaymentSubmissionFieldContainer = styled(Box)`
  margin: 24px 16px 0;

  @media (min-width: 1000px) {
    width: 1000px;
    margin: 16px auto 0;
  }
`;

export const PaymenSubmissionFieldLabel = styled(Box)<{ required?: boolean }>`
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  color: ${Colors.TextMain};
  display: flex;
  align-items: center;
  gap: 5px;

  ${({ required }) =>
    required &&
    `
    &:before {
      content: '*';
      display: block;
      color: ${Colors.SemanticErrorMain}
    }
  `}
`;

export const PaymenSubmissionFieldWrapper = styled(Box)`
  margin-top: 7px;
  .search-filter-container {
    border: 1px solid ${Colors.Neutral03} !important;
  }
  input {
    background-color: ${Colors.Neutralwhite};
  }
`;

export const PaymenSubmissionDropdownField = styled(Box)<{
  disabled?: boolean;
}>`
  background: ${Colors.Neutralwhite};
  border: 1px solid ${Colors.Neutral03};
  border-radius: 4px;

  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: ${Colors.TextMain};

  padding: 12px 36px 12px 8px;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    display: block;

    position: absolute;
    top: 50%;
    right: 10px;

    border-right: 2px solid ${Colors.TextSecondary};
    border-bottom: 2px solid ${Colors.TextSecondary};
    width: 9px;
    height: 9px;
    transform: rotate(-315deg) translateX(-90%);
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: ${Colors.Neutral02};
    border-color: ${Colors.Neutral02};
    color: ${Colors.Neutral04};
    cursor: default;
  `}
`;

export const PaymenSubmissionButtonContainer = styled(Box)`
  z-index: 999;
  position: fixed;
  bottom: 0;
  inset: auto 0 0 0;
  padding: 8px 20px 20px 20px;
  box-shadow: 0px 0px 23px rgba(0, 0, 0, 0.11);
  text-align: center;
  background-color: #fff;
  button {
    width: 100%;
  }
  @media (min-width: 600px) {
    button {
      max-width: 668px;
    }
  }
`;

export const PaymenExpenseButtonContainer = styled(
  PaymenSubmissionButtonContainer
)`
  padding: 38px 20px;
  display: flex;
  gap: 16px;
  justify-content: center;
  button {
    flex: 1;
  }
  @media (min-width: 600px) {
    button {
      max-width: 334px;
    }
  }
`;

export const PaymenSubmissionModalItem = styled(Box)<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 8px;
  gap: 8px;

  background: ${Colors.Neutralwhite};
  border: 1px solid ${Colors.Neutral03};
  border-radius: 4px;

  min-width: 310px;
  cursor: pointer;

  margin-bottom: 5px;

  &:hover {
    color: ${Colors.TextSecondary};
    background-color: ${Colors.Neutral02};
  }

  ${({ selected }) =>
    selected &&
    `
    color: ${Colors.TextSecondary};
    background-color: ${Colors.Neutral02};
  `}
`;

export const PaymenSubmissionModalTitle = styled(Box)`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: ${Colors.BrandGreenMain};
  min-width: 310px;
`;

export const PaymenSubmissionModalTitleLine = styled(Box)`
  width: 100%;
  height: 2px;
  margin: 16px 0 0 0;
  background: linear-gradient(
    90deg,
    rgb(53, 206, 141) 0%,
    rgb(0, 175, 239) 100%
  );
`;

export const PaymenSubmissionModalCloseWrapper = styled(Box)`
  position: absolute;
  right: 16px;
  top: 12px;
  cursor: pointer;
`;

export const PaymenSubmissionModalItemsWrapper = styled(Box)`
  max-height: 80vh;
  overflow-y: auto;
`;

export const FieldWrapper = styled(Box)``;

export const AddExpenseButton = styled(Button)`
  margin-top: 16px;
`;

export const PaymentSubmissionTotal = styled(Box)`
  width: 100%;
  margin-bottom: 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (min-width: 600px) {
    margin: 0 auto;
    max-width: 668px;
  }
`;

export const PaymentSubmissionTotalLabel = styled(Box)`
  text-align: left;
  font-weight: bold;
  line-height: 3rem;
`;

export const PaymentSubmissionTotalValue = styled(Box)`
  text-align: right;
  font-weight: 600;
  font-size: 2rem;
`;

export const PaymentSubmissionExpensesContainer = styled(Box)`
  padding: 20px;
  background: var(--primary-contrast, #fff);
  border-radius: 4px;
  margin: 0 16px 0 16px;
`;

export const PaymentSubmissionExpensesTotalsLabel = styled(Box)`
  font-weight: 700;
  padding-bottom: 8px;
`;

export const PaymentSubmissionExpensesList = styled(Box)`
  padding: 16px 0 4px 0;
  display: grid;
  grid-template-rows: 1fr repeat;
  border-top: solid 1px #cedbea;
  border-bottom: 1px solid rgba(206, 219, 234, 0.4);
`;

export const PaymentSubmissionExpensesListRow = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-bottom: 4px;
  div {
    color: var(--text-main, #333);
    font-size: 14px;
    font-style: normal;
    line-height: normal;
  }
  div:nth-child(1) {
    text-align: left;
    font-weight: 400;
  }
  div:nth-child(2) {
    text-align: right;
    font-weight: 700;
  }
`;

export const PaymentSubmissionExpensesListCell = styled(Box)``;

export const PaymentSubmissionExpenseForm = styled.form`
  padding-bottom: 120px;
`;
